import { connect } from "react-redux";
import { selectRankingFilterLanguageSettings } from "../../balancingSelectors/selectBalancingLanguage";
import { selectRankingSelectedLanguage } from "../../selectors/selectRankInfo";
import { DialogLanguageFilter, } from "../generic/menu-language-filter/DialogLanguageFilter";
import { actionModalClose } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { actionRankingLanguageFilterSelected } from "./actionRanking";
import { HOCRanking } from "./HOCRanking";
var mapDispatch = function (dispatch) { return ({
    onClose: function () { return dispatch(actionModalClose(IdModal.RankingLanguageFilter)); },
    onConfirm: function (filterLanguage) {
        dispatch(actionRankingLanguageFilterSelected(filterLanguage));
        dispatch(actionModalClose(IdModal.RankingLanguageFilter));
    },
}); };
var mapState = function (state) { return ({
    languageSettings: selectRankingFilterLanguageSettings(),
    selectedFilterLanguage: selectRankingSelectedLanguage(state),
}); };
export var DialogRankingLanguageFilter = connect(mapState, mapDispatch)(HOCRanking(DialogLanguageFilter));



//////////////////
// WEBPACK FOOTER
// ./src/features/ranking/DialogRankingLanguageFilter.tsx
// module id = 2894
// module chunks = 3